import React, { useEffect, useState, useCallback } from "react";
import useChangePage from "../../utils/navigation.js";
import { registerUser } from "../../services/api/userService.ts";
import { newHeadset } from "../../services/api/headsetService.ts";
import { useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { Link } from "react-router-dom";

const Register = () => {
  document.title = "Register | Upzet - React Admin & Dashboard Template";
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [surname, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [pid, setPID] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confPasswordVisible, setConfPasswordVisible] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    message: "",
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const pid = urlParams.get("pid");
    setPID(pid);
  }, []);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  const toggleConfPasswordVisibility = () => {
    setConfPasswordVisible(!confPasswordVisible);
  };
  const validateForm = useCallback(() => {
    let newErrors = {};

    if (!email) {
      newErrors.email = "Email is required";
    }

    if (!password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [email, password]);

  const user = {
    user_NAME: username,
    user_SURNAME: surname,
    user_EMAIL: email,
    user_PHONE: phone,
    user_GROUP_ID: 1,
    user_PWD: password,
    user_ROLE_ID: 4,
  };

  const onRegisterPress = useCallback(async () => {
    //setIsRegisterPressed(true);
    //   if (validateForm()) {
    try {
      //dispatch(logUser(userData, navigate));
      const res = await registerUser(user);
      console.log("result headset login: ----------------");
      console.log(res);
      const headsetData = {
        headset_PID: pid,
        headset_NAME: null,
        headset_MODEL: null,
        headset_GROUP_ID: 1,
        headset_USER_ID: res.res.user.user_ID,
      };
      newHeadset(headsetData);
      //console.log("Register data headset login:", email, password);
      setErrors({});
    } catch (error) {
      if (error instanceof Error) {
        console.log("Registration failed:", error.message);
        setErrors({ ...errors, message: error.message });
      }
      //  }
    }
  }, [/*validateForm,*/ user, dispatch, errors]);

  return (
    <React.Fragment>
      <div
        className="bg-pattern"
        style={{ height: "100vh", overflow: "hidden" }}
      >
        <div className="bg-overlay"></div>
        <div className="account-pages pt-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={4}>
                <Card
                  className="mt-5"
                  style={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                  <CardBody className="p-4">
                    <div className="text-center">
                      <img
                        src="/iXiVERSE-NEON.png"
                        alt="test"
                        height="25%"
                        width="25%"
                      />
                      <h3>iXiMANAGER</h3>
                    </div>

                    <h4 className="font-size-18 text-muted text-center mt-2">
                      Free Register
                    </h4>
                    <form className="form-horizontal" action="#">
                      <Row>
                        <Col md={12}>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="username">
                              Username
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="username"
                              placeholder="Enter username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                            />
                          </div>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="surname">
                              User surname
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="surname"
                              placeholder="Enter surname"
                              value={surname}
                              onChange={(e) => setSurname(e.target.value)}
                            />
                          </div>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="useremail">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="useremail"
                              placeholder="Enter email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="phone">
                              Phone number
                            </label>
                            <input
                              type="tel"
                              className="form-control"
                              id="phone"
                              placeholder="Enter phone number"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                            />
                          </div>
                          <div className="mb-4">
                            <label
                              className="form-label"
                              htmlFor="userpassword"
                            >
                              Password
                            </label>
                            <InputGroup>
                              <input
                                type={passwordVisible ? "text" : "password"}
                                className="form-control"
                                id="userpassword"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              <InputGroupText
                                onClick={togglePasswordVisibility}
                              >
                                {passwordVisible ? "Hide" : "Show"}
                              </InputGroupText>
                            </InputGroup>
                          </div>
                          <div className="mb-4">
                            <label
                              className="form-label"
                              htmlFor="confirmPassword"
                            >
                              Confirm password
                            </label>
                            <InputGroup>
                              <input
                                type={confPasswordVisible ? "text" : "password"}
                                className="form-control"
                                id="confirmPassword"
                                placeholder="Confirm password"
                                value={confPassword}
                                onChange={(e) =>
                                  setConfPassword(e.target.value)
                                }
                              />
                              <InputGroupText
                                onClick={toggleConfPasswordVisibility}
                              >
                                {confPasswordVisible ? "Hide" : "Show"}
                              </InputGroupText>
                            </InputGroup>
                          </div>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="term-conditionCheck"
                            />
                            <label
                              className="form-check-label fw-normal"
                              htmlFor="term-conditionCheck"
                            >
                              I accept{" "}
                              <Link to="#" className="text-primary">
                                Terms and Conditions
                              </Link>
                            </label>
                          </div>
                          <div className="d-grid mt-4">
                            <button
                              type="button"
                              className="btn btn-primary waves-effect waves-light"
                              onClick={onRegisterPress}
                            >
                              Register
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p className="text-white-50">
                    Already have an account ?
                    <Link
                      to={`/headset-login?pid=${pid}`}
                      className="fw-medium text-primary"
                    >
                      {" "}
                      Login{" "}
                    </Link>{" "}
                  </p>
                  <p className="text-white-50">
                    © {new Date().getFullYear()} Upzet. Crafted with{" "}
                    <i className="mdi mdi-heart text-danger"></i> by
                    Themesdesign
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Register;
